import { render, staticRenderFns } from "./IframeInfo.vue?vue&type=template&id=5c831c86&"
import script from "./IframeInfo.vue?vue&type=script&lang=js&"
export * from "./IframeInfo.vue?vue&type=script&lang=js&"
import style0 from "./IframeInfo.vue?vue&type=style&index=0&id=5c831c86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports